export const pos = {
  // Titres et en-têtes
  title: 'Punto de Venta',
  subtitle: 'Terminal de caja',
  
  // Panier (Cart)
  cart: {
    title: 'Carrito',
    empty: 'Carrito vacío',
    emptyMessage: 'Añade productos para comenzar',
    items: 'artículo',
    itemsPlural: 'artículos',
    total: 'Total',
    pay: 'Pagar',
    clear: 'Vaciar carrito',
    clearConfirm: '¿Estás seguro de que quieres vaciar el carrito?',
    removeItem: 'Eliminar',
    quantity: 'Cantidad',
    unitPrice: 'Precio unitario',
    lineTotal: 'Total línea'
  },

  // Modal de paiement (CheckoutModal)
  checkout: {
    title: 'Finalizar Pago',
    receiptTitle: 'Ticket de Caja',
    
    // Récapitulatif de commande
    orderSummary: {
      title: 'Resumen del pedido',
      subtotal: 'Subtotal',
      tva: 'IVA',
      totalToPay: 'Total a pagar'
    },

    // Informations client
    customer: {
      name: 'Nombre del cliente',
      namePlaceholder: 'Nombre del cliente',
      phone: 'Teléfono',
      phonePlaceholder: 'Número de teléfono',
      notes: 'Notas',
      notesPlaceholder: 'Notas adicionales...'
    },

    // Méthodes de paiement
    paymentMethods: {
      title: 'Método de pago',
      cash: 'Efectivo',
      card: 'Tarjeta bancaria',
      check: 'Cheque',
      transfer: 'Transferencia',
      mobile: 'Dinero móvil'
    },

    // Montant reçu
    amountReceived: {
      title: 'Monto recibido',
      placeholder: '0.00',
      quickAmounts: 'Montos rápidos',
      insufficient: 'Monto insuficiente',
      change: 'Cambio a devolver'
    },

    // Boutons d'action
    actions: {
      cancel: 'Cancelar',
      finalize: 'Finalizar',
      finalizeCredit: 'Finalizar en Crédito',
      processing: 'Procesando...',
      close: 'Cerrar',
      print: 'Imprimir'
    },

    // Messages d'erreur
    errors: {
      insufficientAmount: 'El monto recibido debe ser mayor o igual al monto total',
      insufficientAmountConfirm: 'El monto recibido es insuficiente. ¿Desea finalizar la venta a crédito?',
      paymentError: 'Error durante el pago. Por favor, inténtalo de nuevo.',
      emptyCart: 'El carrito está vacío. Añade productos antes de proceder al pago.'
    }
  },

  // Ticket de caisse (Receipt)
  receipt: {
    title: 'TICKET DE CAJA',
    saleNumber: 'Venta #',
    client: 'Cliente',
    articles: 'Artículos',
    payment: 'Pago',
    method: 'Método',
    amountReceived: 'Monto recibido',
    change: 'Cambio',
    notes: 'Notas',
    thankYou: '¡Gracias por su compra!',
    keepTicket: 'Conserve este ticket',
    subtotal: 'Subtotal',
    total: 'Total'
  },

  // Barre de statut (StatusBar)
  statusBar: {
    currentSale: 'Venta en curso',
    totalItems: 'Total artículos',
    totalAmount: 'Monto total',
    ready: 'Listo',
    processing: 'En curso...',
    offline: 'Sin conexión',
    online: 'En línea'
  },

  // Grille de produits (ProductGrid)
  productGrid: {
    title: 'Productos',
    search: 'Buscar un producto...',
    noProducts: 'No se encontraron productos',
    noProductsWithCriteria: 'No se encontraron productos con estos criterios',
    noProductsAvailable: 'No hay productos disponibles',
    addToCart: 'Añadir al carrito',
    outOfStock: 'Sin stock',
    lowStock: 'Stock bajo',
    loading: 'Cargando productos...',
    error: 'Error al cargar los productos',
    retry: 'Reintentar',
    stock: 'Stock',
    noBarcode: 'Sin código',
    orders: 'Pedidos',
    newOrder: 'Nuevo pedido',
    order: 'Pedido',
    articles: 'artículos',
    categories: {
      all: 'Todos',
      navigation: 'Navegación de categorías'
    },
    // Commentaires et éléments d'interface
    header: 'Encabezado con búsqueda',
    productGrid: 'Cuadrícula de productos',
    categoryFilters: 'Filtros por categoría con navegación',
    leftArrow: 'Flecha izquierda',
    rightArrow: 'Flecha derecha',
    categoryContainer: 'Contenedor de categorías con scroll'
  },

  // Pavé virtuel (VirtualKeypad)
  virtualKeypad: {
    title: 'Teclado numérico',
    clearCart: 'Vaciar Carrito',
    clearCartConfirm: '¿Estás seguro de que quieres vaciar el carrito?',
    selectors: {
      quantity: 'Cant',
      discount: 'Descuento',
      price: 'Precio'
    },
    buttons: {
      toggleSign: '+/-',
      backspace: '⌫',
      decimal: '.',
      enter: 'Entrar'
    },
    actions: {
      clear: 'Borrar',
      backspace: 'Retroceso',
      toggleSign: 'Cambiar signo'
    }
  },

  // Layouts spécifiques
  layouts: {
    retail: {
      title: 'Comercio minorista',
      products: 'Productos',
      categories: 'Categorías'
    },
    restaurant: {
      title: 'Restaurante',
      menu: 'Menú',
      tables: 'Mesas',
      orders: 'Pedidos en curso',
      table: 'Mesa',
      status: {
        active: 'Activa',
        empty: 'Libre',
        reserved: 'Reservada'
      },
      orderStatus: {
        preparing: 'En preparación',
        ready: 'Listo'
      }
    },
    services: {
      title: 'Servicios',
      services: 'Servicios',
      clients: 'Clientes',
      appointments: 'Citas',
      timer: 'Cronómetro',
      startTimer: 'Iniciar',
      stopTimer: 'Detener',
      resetTimer: 'Reiniciar',
      serviceTime: 'Tiempo de servicio',
      newClient: 'Nuevo cliente',
      searchClient: 'Buscar un cliente...',
      lastVisit: 'Última visita',
      confirmed: 'Confirmado',
      pending: 'Pendiente'
    },
    workshop: {
      title: 'Taller',
      quoteLines: 'Líneas de presupuesto',
      addLine: 'Añadir línea',
      description: 'Descripción',
      quantity: 'Cantidad',
      unitPrice: 'Precio unitario',
      total: 'Total',
      clients: 'Clientes',
      newClient: 'Nuevo cliente',
      searchClient: 'Buscar un cliente...',
      quotePreview: 'Vista previa del presupuesto',
      quoteNumber: 'Presupuesto #',
      date: 'Fecha',
      client: 'Cliente'
    }
  },

  // Notifications
  notifications: {
    paymentSuccess: '¡Pago exitoso!',
    saleSaved: 'Venta guardada exitosamente',
    error: 'Error',
    success: 'Éxito',
    warning: 'Advertencia',
    info: 'Información'
  },

  // Messages généraux
  messages: {
    loading: 'Cargando...',
    saving: 'Guardando...',
    error: 'Ha ocurrido un error',
    success: 'Operación exitosa',
    confirm: '¿Estás seguro?',
    cancel: 'Cancelar',
    ok: 'OK',
    yes: 'Sí',
    no: 'No'
  },

  // Formats de date et monnaie
  formats: {
    currency: '€',
    date: 'DD/MM/YYYY',
    time: 'HH:mm',
    datetime: 'DD/MM/YYYY HH:mm'
  }
}; 